var map = {
	"./bgm1.mp3": 9900,
	"./bgm2.wav": 9611,
	"./bgm3.mp3": 8830,
	"./bgm4.mp3": 2469,
	"./data": 2802,
	"./data.json": 2802,
	"./dewudajipu.jpg": 9882,
	"./diaopai8.jpg": 8903,
	"./fielddata": 2043,
	"./fielddata.json": 2043,
	"./jinsha.jpg": 3635,
	"./jsdata": 1954,
	"./jsdata.json": 1954,
	"./logo.png": 3153,
	"./longshidaier.jpg": 8475,
	"./tabledata": 1235,
	"./tabledata.json": 1235,
	"./testdata": 5925,
	"./testdata.json": 5925
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;